export const EMOJI_CDN = 'https://cdn.jsdelivr.net/npm/@emoji-mart/data@1.0.6/sets/12/native.json';

export const EMOJI_PICKER_CATEGORY = [
  'frequent',
  'people',
  'nature',
  'foods',
  'activity',
  'places',
  'objects',
  'symbols',
];

export const SKINS_ID = {
  NO_SKIN: 0,
  LIGHT: 1,
  MEDIUM_LIGHT: 2,
  MEDIUM: 3,
  MEDIUM_DARK: 4,
  DARK: 5,
};

export const EMOJI_LOCALSTORAGE_KEY = {
  EMOJI_DATA: 'emoji-data',
  EMOJI_RECENT: 'emoji-recent',
};

export const CATEGORIES_ID = {
  FREQUENT: 'frequent',
  PEOPLE: 'people',
  NATURE: 'nature',
  FOODS: 'foods',
  ACTIVITY: 'activity',
  PLACES: 'places',
  OBJECTS: 'objects',
  SYMBOLS: 'symbols',
  FLAGS: 'flags',
};

export const LIMIT_FREQUENT_EMOJIS = 30;

export const WORDING_NO_RECENT_EMOJI = 'Belum ada emoji yang telah digunakan';

export const EMOJI_LIST_ID = 'emoji-list';
